import useTrans from '../../../hooks/useTrans'
import { trackingAddCart } from '../../../utils/gtm.js'
import { Button, Tooltip, Trans } from '../../atoms'
import { Cart, Clock, Edit, Info } from '../../atoms/NewIcons'
import DataTableRowCreaOfferta from '../DataTableRowCreaOfferta/DataTableRowCreaOfferta.jsx'
import DatatableRowCart from '../DatatableRowCart/DatatableRowCart'
import DatatableRowPersonalizzazione from '../DatatableRowPersonalizzazione/DatatableRowPersonalizzazione'

const ArticoliPersonalizzati = ({
  righe,
  salvati = false,
  MoveToMainPersonalizzazione,
  MoveToLaterPersonalizzazione,
  MoveToLater,
  Delete,
  setOpenModalNota,
  setId,
  setCodice,
  setNota,
  setOpenNomeLavorazioneModal,
  setNomeLavorazione,
  setOpenModalRimuovi,
  setOpenModalQuantita,
  EliminaPersonalizzazione,
  carrelloMain,
  creaOfferta,
}) => {
  const t = useTrans()

  const onEditNomeLavorazioneClick = (personalizzazione) => {
    setNomeLavorazione(
      personalizzazione.nome_lavorazione_manuale
        ? personalizzazione.nome_lavorazione_no_incrementale
        : null
    )
    setId(personalizzazione.id)
    setOpenNomeLavorazioneModal(true)
  }

  return (
    <>
      {righe.map((personalizzazione) => (
        <div className="articoli-personalizzati__block" key={personalizzazione.id}>
          {!creaOfferta && (
            <div className="articoli-personalizzati__block-head">
              <p className="articoli-personalizzati__subtitle">
                <Trans chiave="Personalizzazione" /> {personalizzazione.nome_lavorazione}
                <button
                  className="articoli-personalizzati__lavorazione__edit"
                  onClick={() => onEditNomeLavorazioneClick(personalizzazione)}
                >
                  <span className="articoli-personalizzati__info">
                    <Edit />
                  </span>
                </button>
                {!personalizzazione.nome_lavorazione_manuale && (
                  <span className="articoli-personalizzati__info">
                    <Tooltip label={t('Identificativo generato automaticamente')}>
                      <Info />
                    </Tooltip>
                  </span>
                )}
              </p>
              {salvati ? (
                <Button
                  className="articoli-personalizzati__head-button"
                  variant="ghost"
                  colorVariant="black"
                  size="medium"
                  label={t('Sposta nel carrello')}
                  icon={<Cart />}
                  icon_pos="left"
                  onClick={() => {
                    MoveToMainPersonalizzazione(personalizzazione.id)
                    trackingAddCart(personalizzazione, 'standard_order')
                  }}
                  disabled={!MoveToMainPersonalizzazione}
                />
              ) : (
                <Button
                  className="articoli-personalizzati__head-button"
                  variant="ghost"
                  colorVariant="black"
                  size="medium"
                  label={t('Salva per dopo')}
                  icon={<Clock />}
                  icon_pos="left"
                  onClick={() => MoveToLaterPersonalizzazione(personalizzazione.id)}
                  disabled={!MoveToLaterPersonalizzazione}
                />
              )}
            </div>
          )}
          {personalizzazione.righe_carrello.map((element, _i) =>
            creaOfferta ? (
              <DataTableRowCreaOfferta
                riga={element}
                rigaId={element?.id}
                personalizzazioneId={element?.personalizzazione_carrello_id}
                creaOfferta={creaOfferta}
                margineInput={creaOfferta?.margineInput}
                totaleQuotazione={creaOfferta?.totaleQuotazione}
                preview={creaOfferta?.preview}
                articolo={element.articolo}
                quantita={element.quantita}
                key={element.id}
                even={_i % 2 == 0}
              />
            ) : (
              <DatatableRowCart
                carrelloMain={carrelloMain}
                isSalvatoPerDopo={salvati}
                isPersonalizzato={true}
                isPersonizzabile={!element.escludi_da_listino_di_stampa}
                articolo={element.articolo}
                quantita={element.quantita}
                key={element.id}
                id={element.id}
                riga={element}
                nota={element.nota}
                MoveToLater={!salvati && MoveToLater}
                Delete={Delete}
                setOpen={setOpenModalNota}
                setId={setId}
                saveCodice={setCodice}
                setNota={setNota}
                setDeleteOpen={setOpenModalRimuovi}
                setOpenModalQuantita={setOpenModalQuantita}
                even={_i % 2 == 0}
              />
            )
          )}

          <DatatableRowPersonalizzazione
            creaOfferta={creaOfferta}
            onDelete={() => EliminaPersonalizzazione(personalizzazione?.righe_carrello)}
            id={personalizzazione.id}
            quantita={personalizzazione?.quantita_personalizzazione}
            prezzo_personalizzazione_unitario={
              personalizzazione?.righe_carrello[0].prezzo_personalizzazione_unitario
            }
            stesso_logo={personalizzazione.stesso_logo}
            posizione={personalizzazione.posizioni[0].personalizzazione.posizione.nome}
            numero_colori={
              personalizzazione.posizioni[0].personalizzazione.numero_colori_descrizione
            }
            posizioni={personalizzazione.posizioni}
            totale_personalizzazione={personalizzazione.totale_personalizzazione}
            tecnica={personalizzazione.posizioni[0].personalizzazione.tecnica.nome}
            prodotto={
              personalizzazione.posizioni
                ? personalizzazione.posizioni[0].personalizzazione.prodotto
                : null
            }
            codice={personalizzazione.righe_carrello[0]?.articolo?.prodotto?.codice}
          />
        </div>
      ))}
    </>
  )
}

export default ArticoliPersonalizzati
